import styled, { css } from 'styled-components';
import DefaultTooltip from '../Default';

export const Container = styled(DefaultTooltip)`
  ${({ theme }) => css`
    color: ${theme.colors.green};
  `}
`;
